import { render, staticRenderFns } from "./VehicleExpenseStats.vue?vue&type=template&id=f2cf461c&scoped=true"
import script from "./VehicleExpenseStats.vue?vue&type=script&lang=js"
export * from "./VehicleExpenseStats.vue?vue&type=script&lang=js"
import style0 from "./VehicleExpenseStats.vue?vue&type=style&index=0&id=f2cf461c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf461c",
  null
  
)

export default component.exports